"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputGroup = function (props) {
    return (react_1.default.createElement("div", { className: "formsCommon-FormGroup_Wrapper" },
        react_1.default.createElement("div", { className: "formsCommon-FormGroup_Title" },
            props.label && react_1.default.createElement("span", null, props.label),
            props.required &&
                react_1.default.createElement("span", { className: "formsCommon-FormGroup_RequiredLabel" }, "(\u203B\u5FC5\u9808)"),
            props.optional &&
                react_1.default.createElement("span", { className: "formsCommon-FormGroup_OptionalLabel" }, "(\u4EFB\u610F)")),
        props.children));
};
exports.default = InputGroup;
